import styled from "styled-components";
export const Container = styled.div`
	position: relative;
	padding-top: 24px;
	width: 100%;
	display: flex;
	justify-content: center;
`;
